import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';

@Component({
    selector: 'app-label-type-three',
    imports: [CommonModule, FormsModule, ReactiveFormsModule],
    templateUrl: './label-type-three.component.html',
    styleUrl: './label-type-three.component.css'
})
export class LabelTypeThreeComponent {
  @Input() formGroup!: FormGroup;
  @Input() fields: any;
  @Input() activeModalContext: any;
  getDisplayName(fields: any) {
    let name = fields.displayName || '';
    if (this.activeModalContext) {
      Object.keys(this.activeModalContext).forEach((key) => {
        const value = this.activeModalContext[key];
        const regex = new RegExp(`{{\\s*${key}\\s*}}`, 'g');

        name = name.replace(regex, value);
      });
    }

    return name;
  }
}
